import { render } from "./Drive.vue?vue&type=template&id=55161b1c"
import script from "./Drive.vue?vue&type=script&lang=ts"
export * from "./Drive.vue?vue&type=script&lang=ts"

import "./Drive.vue?vue&type=style&index=0&id=55161b1c&lang=css"
script.render = render

export default script